import get from 'lodash.get';

const getOptionAttributesValues = (state, option) => {
  const { attributes, elementIds } = option;

  return attributes.map((attribute) => {
    if (elementIds.length > 1) {
      return elementIds
        .map((elementId) => get(state, `${elementId}.${attribute}`))
        .filter((value) => value !== undefined);
    }

    return get(state, `${elementIds[0]}.${attribute}`);
  });
};

const getOptionFlatAttributesValues = (state, option) =>
  getOptionAttributesValues(state, option).flat();

export default getOptionAttributesValues;
export { getOptionFlatAttributesValues };
